export enum AuthSectionEnum {
  Email = "email",
  Password = "password",
  ForgotPassword = "forgotPassword",
  ResetPassword = "resetPassword",
};

export enum ModalEnum {
  AuthModal = "auth",
  PrePaymentModal = "prePaymentModal",
  PaymentSuccessModal = "paymentSuccessModal",
  PaymentFailedModal = "paymentFailedModal",
  PayAfterAuthModal = "payAfterAuthModal",
  LoadingModal = "loadingModal",
  DirectPurchaseModal = "directPurchaseModal",
  CampaignModal = "campaignModal",
  // Add more modals here as needed
}
